//Corresponding API model located in API project at
// API\IMS.Models\Services\Applications\Applications\AppManagementModel.cs
//Only edit if the AppManagementModel model or one of its dependencies were updated in the API causing error

import { AppAux, AppInfo, AppModel } from '../Apps';
import ApprovalsRequest from './ApprovalRequest';

export default class AppManagementModel extends AppModel {
	constructor(response) {
		super(response);
		this.appMaster =
			response && response.AppMaster
				? new AppMaster(response.AppMaster)
				: new AppMaster();
		this.appAux =
			response && response.AppAux
				? new AppAux(response.AppAux)
				: new AppAux();
		this.UPMCApplication =
			response && response.UPMCApplication
				? new AppInfo(response.UPMCApplication)
				: new AppInfo();
		this.isServiceAccountOnly =
			response && response.IsServiceAccountOnly != null
				? response.IsServiceAccountOnly
				: !this.appMaster.activeFlag; //this logic subject to change

		this.serviceAccountTypes =
			response && response.ServiceAccountTypes
				? parseServiceAccountTypes(response.ServiceAccountTypes)
				: [];
		this.notificationEvents =
			response && response.NotificationEvents
				? parseNotificationEvents(response.NotificationEvents)
				: [];
		this.extensions =
			response && response.Extensions
				? parseExtensions(response.Extensions)
				: [];
		this.appExtensions =
			response && response.AppExtensions
				? parseAppExtensions(response.AppExtensions)
				: [];
		this.components =
			response && response.Components
				? parseComponents(response.Components)
				: [];
		this.dependencies =
			response && response.Dependencies
				? parseAppDependencies(response.Dependencies)
				: [];
		this.errors = response ? response.Errors : []; //[]

		function parseNotificationEvents(notificationEvents) {
			if (notificationEvents) {
				return notificationEvents.map(event => {
					return new NotificationEvent(event);
				});
			} else {
				return [];
			}
		}

		function parseExtensions(extensions) {
			if (extensions) {
				return extensions.map(extension => {
					return new Extension(extension);
				});
			} else {
				return [];
			}
		}

		function parseAppExtensions(appExtensions) {
			if (appExtensions) {
				return appExtensions.map(appExtension => {
					return new AppExtension(appExtension);
				});
			} else {
				return [];
			}
		}
		function parseComponents(components) {
			if (components) {
				return components.map(component => {
					return new AppComponent(component);
				});
			} else {
				return [];
			}
		}

		function parseServiceAccountTypes(serviceAccountTypes) {
			if (serviceAccountTypes) {
				return serviceAccountTypes.map(serviceAccountType => {
					return new ServiceAccountType(serviceAccountType);
				});
			} else {
				return [];
			}
		}

		function parseAppDependencies(dependencies) {
			if (dependencies) {
				return dependencies.map(dependency => {
					return {
						requestedAppId: dependency.requestedAppId,
						dependentAppId: dependency.dependentAppId,
					};
				});
			} else {
				return [];
			}
		}
	}
}

export class AppMaster {
	constructor(baseApp_Master) {
		this.id = baseApp_Master ? baseApp_Master.ID : null;
		this.name = baseApp_Master ? baseApp_Master.Name : null;
		this.description = baseApp_Master ? baseApp_Master.Description : null;
		this.appTypeID = baseApp_Master ? baseApp_Master.AppTypeID : null;
		this.owner = baseApp_Master ? baseApp_Master.Owner : null;
		this.patientData = baseApp_Master ? baseApp_Master.PatientData : null;
		this.reviewer = baseApp_Master ? baseApp_Master.Reviewer : null;
		this.activeFlag = baseApp_Master ? baseApp_Master.Active_Flag : true;
		this.sentillionFlag = baseApp_Master
			? baseApp_Master.SentillionFlag
			: null;
		this.validationKey = baseApp_Master
			? baseApp_Master.ValidationKey
			: null;
		this.formName = baseApp_Master ? baseApp_Master.Form_Name : null;
		this.allowMultipleRoles = baseApp_Master
			? baseApp_Master.AllowMultipleRoles
			: null;
		this.sortOrder = baseApp_Master ? baseApp_Master.SortOrder : null;
		this.notifyGroup = baseApp_Master ? baseApp_Master.NotifyGroup : null;
		this.firewallFlag = baseApp_Master
			? baseApp_Master.Firewall_flag
			: null;
	}

	static validate(appMaster) {
		let validationErrors = [];
		////name
		const disallowedCharacters = ['$', '`', '%', '^', '!', '*', '|', '~'];
		if (disallowedCharacters.some(char => appMaster.name?.includes(char))) {
			validationErrors.push({
				message: `Special characters not allowed: ${disallowedCharacters.join(
					', '
				)}`,
				field: 'name',
			});
		}
		if (appMaster.name === '' || appMaster.name === null) {
			validationErrors.push({
				message: 'Application Name cannot be blank',
				field: 'name',
			});
		}
		return validationErrors;
	}
}

export class Extension {
	constructor(extension) {
		this.fiid = extension ? extension.FIID : null;
		this.search = extension ? extension.Search : null;
		this.description = extension ? extension.Description : null;
		this.full = extension ? extension.Full : null;
		this.short = extension ? extension.Short : null;
		this.extensionType = extension ? extension.ExtensionType : null;
		this.appID = extension ? extension.AppID : null;
		this.order = extension ? extension.Order : null;
		this.hide = extension ? extension.Hide : null;
		this.formatGroup = extension ? extension.FormatGroup : null;
		this.privilegedFlag = extension ? extension.PrivilegedFlag : null;
		this.f_Component_ID = extension ? extension.F_Component_ID : null;
		this.f_Save_Override_Value = extension
			? extension.F_Save_Override_Value
			: null;
	}
}

export class AppComponent {
	constructor(component) {
		this.id = component ? component.ID : null;
		this.appID = component ? component.AppID : null;
		this.extension = component ? new Extension(component.Extension) : null;
		this.componentTypeID = component ? component.ComponentTypeID : null;
		this.componentType = component
			? new ComponentType(component.ComponentType)
			: null;
		this.label = component ? component.Label : null;
		this.subLabel = component ? component.SubLabel : null;
		this.required = component ? component.Required : false;
		this.order = component ? component.Order : 0;
		this.activeFlag = component ? component.ActiveFlag : null;
		this.modeAdd = component ? component.ModeAdd : null;
		this.modeModify = component ? component.ModeModify : null;
		this.modeReactivate = component ? component.ModeReactivate : null;
		this.visible = component ? component.Visible : true;
		this.defaultValue = component ? component.DefaultValue : null;
		this.validationRoute = component ? component.ValidationRoute : null;
		this.populationRoute = component ? component.PopulationRoute : null;
		this.clientMethod = component ? component.ClientMethod : null;
		this.extras = component ? component.Extras : null;
		this.appRoleFlag = component ? component.AppRoleFlag : null;
		this.createDate = component ? component.CreateDate : null;
		this.maintDate = component ? component.MaintDate : null;
		this.appRoleKey = component ? component.AppRoleKey : null;
		this.prePopulationFlag = component ? component.PrePopulationFlag : null;
		this.hasDependant = component ? component.HasDependant : null;
		this.appData =
			component && component.AppData
				? parseAppData(component.AppData)
				: [];
		this.componentDependencies =
			component && component.ComponentDependencies
				? parseComponentDependencies(component.ComponentDependencies)
				: [];

		function parseAppData(appData) {
			return appData.map(data => {
				return new AppData(data);
			});
		}

		function parseComponentDependencies(componentDependencies) {
			return componentDependencies.map(componentDependency => {
				return new ComponentDependency(componentDependency);
			});
		}
	}

	static validate(component) {
		let validationErrors = [];
		//currently no validations required, leaving validation code to support future validation requirments for Components
		return validationErrors;
	}
}

export class ComponentDependency {
	constructor(componentDependency) {
		this.id = componentDependency ? componentDependency.ID : null;
		this.componentID = componentDependency
			? componentDependency.ComponentID
			: null;
		this.componentDependantID = componentDependency
			? componentDependency.ComponentDependantID
			: null;
		this.conditionalAppDataID = componentDependency
			? componentDependency.ConditionalAppDataID
			: null;
		this.activeFlag = componentDependency
			? componentDependency.ActiveFlag
			: null;
		this.component = componentDependency
			? componentDependency.Component
			: null;
		this.componentDependant = componentDependency
			? new AppComponent(componentDependency.ComponentDependant)
			: null;
		this.conditionalAppData = componentDependency
			? new AppData(componentDependency.ConditionalAppData)
			: null;
	}

	static validate(componentDependency) {
		let validationErrors = [];
		//require componentID:
		if (componentDependency.componentID == null) {
			validationErrors.push({
				message: 'Component ID cannot be null',
				field: 'componentID',
			});
		}
		//require componentDependantID:
		if (componentDependency.componentDependantID == null) {
			validationErrors.push({
				message: 'Required',
				field: 'componentDependantID',
			});
		}
		//require conditionalAppDataID:
		if (componentDependency.conditionalAppDataID == null) {
			validationErrors.push({
				message: 'Required',
				field: 'conditionalAppDataID',
			});
		}
		return validationErrors;
	}
}

export class AppData {
	constructor(appData) {
		this.id = appData ? appData.ID : null;
		this.search = appData ? appData.Search : null;
		this.full = appData ? appData.Full : null;
		this.short = appData ? appData.Short : null;
		this.description = appData ? appData.Description : null;
		this.lockTime = appData ? appData.LockTime : null;
		this.lockUser = appData ? appData.LockUser : null;
		this.maintUser = appData ? appData.MaintUser : null;
		this.createSystem = appData ? appData.CreateSystem : null;
		this.createDate = appData ? appData.CreateDate : null;
		this.createUser = appData ? appData.CreateUser : null;
		this.fieldValue = appData ? appData.FieldValue : null;
		this.activeFlag = appData ? appData.ActiveFlag : null;
		this.extension = appData ? new Extension(appData.Extension) : null;
		this.orderBy = appData ? appData.OrderBy : null;
		this.controlType = appData ? appData.ControlType : null;
		this.privilegedFlag = appData ? appData.PrivilegedFlag : null;
		this.componentID = appData ? appData.ComponentID : null;
	}

	static validate(appData) {
		let validationErrors = [];
		//require full:
		if (appData.full === null || appData.full === '') {
			validationErrors.push({
				message: 'Full cannot be blank',
				field: 'full',
			});
		}
		//require short
		if (appData.short === null || appData.short === '') {
			validationErrors.push({
				message: 'Short cannot be blank',
				field: 'short',
			});
		}
		//require description
		if (appData.description === null || appData.description === '') {
			validationErrors.push({
				message: 'Description cannot be blank',
				field: 'description',
			});
		}
		//require field value
		if (appData.fieldValue === null || appData.fieldValue === '') {
			validationErrors.push({
				message: 'Field Value cannot be blank',
				field: 'fieldValue',
			});
		}
		return validationErrors;
	}
}

export class ComponentType {
	constructor(componentType) {
		this.id = componentType ? componentType.Id : null;
		this.description = componentType ? componentType.Description : null;
		this.activeFlag = componentType ? componentType.ActiveFlag : null;
	}
}

export class AppExtension {
	constructor(appExtension) {
		this.id = appExtension ? appExtension.ID : null;
		this.appID = appExtension ? appExtension.AppID : null;
		this.extension = appExtension
			? new Extension(appExtension.Extension)
			: new Extension();
		this.notifyAppCre_Email = appExtension
			? appExtension.NotifyAppCre_Email
			: null;
		this.approveAppCre_Email = appExtension
			? appExtension.ApproveAppCre_Email
			: null;
		this.order = appExtension ? appExtension.Order : null;
		this.search = appExtension ? appExtension.Search : null;
		this.description = appExtension ? appExtension.Description : null;
		this.full = appExtension ? appExtension.Full : null;
		this.short = appExtension ? appExtension.Short : null;
	}
}

export class NotificationEvent {
	constructor(notificationEvent) {
		this.eventTypeID =
			notificationEvent && notificationEvent.EventTypeID
				? notificationEvent.EventTypeID
				: null;
		this.eventType =
			notificationEvent && notificationEvent.EventType
				? new EventType(notificationEvent.EventType)
				: new EventType();
		this.actionID =
			notificationEvent && notificationEvent.ActionID
				? notificationEvent.ActionID
				: null;
		this.appID =
			notificationEvent && notificationEvent.AppID
				? notificationEvent.AppID
				: null;
		this.recipients =
			notificationEvent && notificationEvent.Recipients
				? notificationEvent.Recipients
				: null;
		this.description =
			notificationEvent && notificationEvent.Description
				? notificationEvent.Description
				: null;
	}
}

export class EventType {
	constructor(eventType) {
		this.id = eventType && eventType.ID ? eventType.ID : null;
		this.name = eventType && eventType.Full ? eventType.Full : null;
		this.description =
			eventType && eventType.Description ? eventType.Description : null;
		this.category =
			eventType && eventType.Category ? eventType.Category : null;
		this.mqLabel =
			eventType && eventType.MQLabel ? eventType.MQLabel : null;
		this.requestStatus =
			eventType && eventType.RequestStatus
				? eventType.RequestStatus
				: null;
	}
}

export class AppExport {
	/**
	 * @param {AppManagementModel} app
	 * @param {ApprovalsRequest} approvalSingle
	 * @param {ApprovalsRequest} approvalMulti
	 * @param {AppManagementModel} notifications
	 */
	constructor(
		app = new AppManagementModel(),
		approvalSingle = new ApprovalsRequest(),
		approvalMulti = new ApprovalsRequest(),
		notifications = new AppManagementModel()
	) {
		this.app = app;
		this.approvals = {
			single: approvalSingle,
			multi: approvalMulti,
		};
		this.notifications = notifications;
	}
}

//BaseAppServiceAccount.cs in api
export class ServiceAccountType {
	constructor(serviceAccountType) {
		this.id =
			serviceAccountType && serviceAccountType.ID
				? serviceAccountType.ID
				: null;
		this.description =
			serviceAccountType && serviceAccountType.Description
				? serviceAccountType.Description
				: null;
		this.appID =
			serviceAccountType && serviceAccountType.AppID
				? serviceAccountType.AppID
				: null;
		this.allowNew = serviceAccountType ? serviceAccountType.AllowNew : 1;
		this.allowModify = serviceAccountType
			? serviceAccountType.AllowModify
			: 0;
		this.allowModAdd = serviceAccountType
			? serviceAccountType.AllowModAdd
			: 0;
		this.accountTypeID =
			serviceAccountType && serviceAccountType.AccountTypeID
				? serviceAccountType.AccountTypeID
				: null;
		this.subUserTypeID =
			serviceAccountType && serviceAccountType.SubUserTypeID
				? serviceAccountType.SubUserTypeID
				: null;
		this.accountType =
			serviceAccountType && serviceAccountType.AccountType
				? new AccountType(serviceAccountType.AccountType)
				: new AccountType();
		this.subUserType =
			serviceAccountType && serviceAccountType.SubUserType
				? new UserType(serviceAccountType.SubUserType)
				: new UserType();
	}
}

export class AccountType {
	constructor(accountType) {
		this.id = accountType ? accountType.ID : null;
		this.search = accountType ? accountType.Search : null;
		this.description = accountType ? accountType.Description : null;
		this.full = accountType ? accountType.Full : null;
		this.short = accountType ? accountType.Short : null;
		this.employeeFlag = accountType ? accountType.EmployeeFlag : null;
		this.nonEmployeeFlag = accountType ? accountType.NonEmployeeFlag : null;
		this.activeFlag = accountType ? accountType.ActiveFlag : null;
		this.primaryHRFeed = accountType ? accountType.PrimaryHRFeed : null;
		this.superUser = accountType ? accountType.SuperUser : null;
	}
}

export class UserType {
	constructor(userType) {
		this.id = userType ? userType.ID : null;
		this.full = userType ? userType.Full : null;
		this.description = userType ? userType.Description : null;
		this.primaryFlag = userType ? userType.PrimaryFlag : null;
		this.serviceFlag = userType ? userType.ServiceFlag : null;
		this.parentTypeID = userType ? userType.ParentTypeID : null;
		this.activeFlag = userType ? userType.ActiveFlag : null;
		this.privacyOfficerEmail = userType
			? userType.PrivacyOfficerEmail
			: null;
		this.ouAssigned = userType ? userType.OUAssigned : null;
		this.notice = userType ? userType.Notice : null;
	}
}
